import { defineMessages } from 'react-intl'

export default defineMessages({
    orderId: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.orderId',
        defaultMessage: 'Order ID',
    },
    orderIdPlaceholder: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.orderIdPlaceholder',
        defaultMessage: 'Order ID',
    },
    taskId: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.taskId',
        defaultMessage: 'Task ID',
    },
    taskIdPlaceholder: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.taskIdPlaceholder',
        defaultMessage: 'Task ID',
    },
    suppliers: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.suppliers',
        defaultMessage: 'Suppliers',
    },
    suppliersPlaceholder: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.suppliersPlaceholder',
        defaultMessage: 'Suppliers',
    },
    search: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.search',
        defaultMessage: 'Search',
    },
    export: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.export',
        defaultMessage: 'Export Fakturafil csv',
    },
    showFullTaskRow: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.showFullTaskRow',
        defaultMessage: 'Show full task row',
    },
    showLesserTaskRow: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.showLesserDataRow',
        defaultMessage: 'Show lesser task row',
    },
    dateFrom: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.dateFrom',
        defaultMessage: 'Date from',
    },
    dateTo: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.dateTo',
        defaultMessage: 'Date To',
    },
    reportRules: {
        id: 'containers.Accounting.AccountingToBePaidTasksPage.components.ReportHeader.reportRules',
        defaultMessage: "RULES to include tasks that have been:\n1. Created after the 29th of February 2024\n2. Task cost > 0\n3. Task has not been paid yet\n4. Tasks with order partner ADRENALINE (They don’t upload files)\n5. USAGE tasks with a status where the supplier approved the task\n6. ST, LSA and LSP does not upload files, and does not need approval\n7. Other task types where status change includes a file upload\n8. Task is not on hold\n9. Supplier partner must be the same as logged in user partner\n10. Supplier economic creditor id is not 9999 (AME users)"
    }
})
